import { render, staticRenderFns } from "./bometerdata.vue?vue&type=template&id=1a88480c&"
import script from "./bometerdata.vue?vue&type=script&lang=js&"
export * from "./bometerdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports